import { createCRUDHook } from './createCRUDHook';
import { OpportunityDto } from 'utils/models';
import { CRM_OPPORTUNITY } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<OpportunityDto>({
  entityName: 'Opportunity',
  endpoint: CRM_OPPORTUNITY,
});

export const OpportunityContext = Context;
export const useOpportunityManager = useManager;
export const useOpportunity = useConsumer;
